import { render, staticRenderFns } from "./ProxyDashboard.vue?vue&type=template&id=5cfe7378&scoped=true"
import script from "./ProxyDashboard.vue?vue&type=script&lang=js"
export * from "./ProxyDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe7378",
  null
  
)

export default component.exports